export default {
    locale: 'bg',
    country: 'BG',
    loginForm: {
        byAccountBtn: 'Вход за парола за акаунт',
        byPhoneBtn: 'Вход за мобилен номер',
        accountPlaceholder: 'Моля, въведете акаунта (акаунт по подразбиране АДМИНИСТРАТОР)',
        passwordPlaceholder: 'Моля, въведете паролата (парола по подразбиране 123456)',
        autoLogin: 'автоматично вписване',
        forgetBtn: 'Забравена парола',
        loginBtn: 'Влизам',
        byAccountTip: {
            emptyErr: 'Акаунтът не може да бъде празен'
        },
        byPasswordTip: {
            emptyErr: 'паролата не може да бъде празна'
        },
        byValidTip: {
            emptyErr: 'трябва да се попълни код за проверка'
        },
        sendMsg: {
            repeatErr: 'Не изпращайте многократно',
            success: 'Успешен',
            codeTip: 'Вашият код за потвърждение е'
        },
        phonePlaceholder: 'Моля, въведете телефонен номер',
        validPlaceholder: 'Код за потвърждение',
        validBtn: 'вземете код за проверка',
        loginSuccess: 'успешен вход'
    },
    menuObj: {
        basicFeature: 'Основна способност',
        cpUse: 'Използване на компоненти',
        childMenu: {
            0: 'Основна рамка',
            1: 'Основна способност',
            '0-0': 'Vue',
            '0-1': 'Дизайн на мравки',
            '0-2': 'Близо до Admin Vue',
            '1-0': 'Рамкова функция',
            '1-0-0': 'Конфигурация на проекта',
            '1-0-1': 'Дневник на предния панел',
            '1-0-2': 'Местен подигравка',
            '1-0-3': 'глобализация',
            '1-0-4': 'Речник на данни',
            '1-0-5': 'EventBus',
            '1-0-6': 'Набор от инструменти',
            '1-0-7': 'Контрол на достъпа',
            '1-0-8': 'горещ клавиш',
            '1-1': 'Функция на страницата',
            '1-1-0': 'Страница с компоненти',
            '1-1-1': 'URL страница',
            '1-1-2': 'Няма страница за разрешение',
            '1-1-3': '404 стр'
        },
        errorTip: {
            notfoundTip: 'Компонентът по този път не бе намерен',
            emptyErr: 'Неконфигуриран път на компонента'
        }
    },
    coreMenuObj: {
        defaultMenu: {
            home: 'У дома'
        }
    },
    sysInfo: {
        sysIntro: 'Полезна рамка за разработка отпред и отзад, базирана на Vue и Ant Design'
    },
    requestInfo: {
        withoutUrl: 'Адресът на заявката не може да бъде празен',
        networkErr: 'Заявката за мрежа не бе успешна, моля, опитайте отново по-късно'
    },
    localeMap: {
        ar: 'Арабски',
        bg: 'български',
        ca: 'Каталунски',
        cs: 'Чешки',
        da: 'Датски',
        de: 'Немски',
        el: 'Гръцки',
        'en-gb': 'Английски',
        en: 'Английски',
        es: 'Испански',
        et: 'Естонски',
        fa: 'Персийски',
        fi: 'Финландски',
        fr: 'Френски',
        he: 'Иврит',
        hi: 'Хинди',
        hr: 'Хърватски',
        hu: 'Унгарски',
        hy: 'Арменски',
        id: 'Индонезийски',
        is: 'Исландски',
        it: 'Италиански ',
        ja: 'Японски',
        kn: 'Каннада',
        ko: 'Корейски',
        'ku-iq': 'Централен кюрдски',
        lv: 'Централен кюрдски',
        mk: 'Македонски',
        'mn-mn': 'Монголски',
        'ms-my': 'Малайски',
        nb: 'Норвежки',
        'ne-np': 'Непалски',
        'nl-be': 'Фламандски',
        nl: 'Холандски',
        pl: 'Полски',
        'pt-br': 'Бразилски португалски',
        pt: 'Европейски португалски',
        ro: 'Румънски',
        ru: 'руски език',
        sk: 'Словашки',
        sl: 'Словенски',
        sr: 'Сръбски',
        sv: 'Шведски',
        ta: 'Тамилски',
        th: 'Тайландски',
        tr: 'Турски',
        uk: 'Украински',
        vi: 'Виетнамски',
        'zh-cn': 'Опростен китайски',
        'zh-tw': 'традиционен китайски'
    },
    tagObj: {
        closeAll: 'Затворете всички раздели',
        closeCur: 'Затворете текущия раздел',
        closeOther: 'Затворете други раздели',
        closeRight: 'Затворете десния етикет',
        singlePage: 'Независима страница',
        refreshPage: 'страница за опресняване',
        affixPage: 'Закачване на страница',
        cancelAffixPage: 'Освободете',
        errorTip: {
            homePageCloseError: 'Началната страница няма право да се затваря',
            affixPageCloseError: 'Не е разрешено затварянето на фиксирана страница',
            homePageAffixError: 'Началната страница не може да бъде откачена'
        },
        checkSave: 'Искате ли да затворите страницата? (Моля, уверете се, че съдържанието на страницата, маркирана в червено, е запазено)',
        cancelClose: 'Операцията за затваряне е отменена'
    },
    personalCenter: {
        frontendLog: 'Дневник на предния панел',
        customSetting: 'Персонализация',
        customClean: 'Ясна конфигурация',
        cacheClean: 'Изпразнете кеша',
        logout: 'отписване',
        errorTip: {
            cleanSuccess: 'Изпразнете успешно'
        }
    },
    errorPage: {
        errorTip: {
            notfoundTip: 'За съжаление посетената от вас страница не съществува',
            notrightTip: 'За съжаление нямате разрешение за достъп до тази страница',
            noserviceTip: 'За съжаление възникна проблем със сървъра, моля, опитайте отново по-късно'
        },
        btnText: 'Затворете страницата'
    },
    searchPanel: {
        btn: {
            search: 'Попитайте',
            shrink: 'Прибирайте',
            reset: 'Нулиране',
            unshrink: 'Разгънете'
        }
    },
    logline: {
        list: 'Дневник списък',
        detail: 'Подробности за дневника',
        btnList: {
            export: 'Износ',
            remove: 'Празно'
        },
        time: {
            plh: 'Моля, изберете времеви диапазон',
            range: 'краен срок',
            halfDay: 'Половин ден',
            oneDay: 'в един ден',
            weekDay: 'в рамките на една седмица',
            monthDay: 'В рамките на един месец'
        },
        type: {
            logType: 'Тип дневник',
            plh: 'Моля, изберете тип дневник'
        },
        tableColumns: {
            index: 'Сериен номер',
            desc: 'Описание на дневника',
            type: 'Тип дневник',
            time: 'време',
            op: 'работещ'
        },
        request: 'Заявете данни',
        error: {
            cancel: 'Празна операция е отменена',
            confirm: 'Искате ли да изчистите регистрационния файл? (Ако дневникът се изпразни, той не може да бъде извлечен)'
        },
        success: 'Дневникът е изпразнен'
    },
    comTable: {
        delete: {
            title: 'Ясна конфигурация'
        },
        columns: {
            title: 'Настройки на колона',
            all: 'Избери всичко',
            reset: 'Нулиране',
            fixedLeft: 'Фиксиран вляво',
            fixedRight: 'Фиксирано вдясно',
            cancelFixed: 'Освободете'
        },
        size: {
            title: 'Височина на реда',
            small: 'тесен',
            normal: 'в',
            large: 'ширина'
        },
        fullscreen: 'цял екран',
        unFullscreen: 'Анулиране на цял екран'
    },
    normalBtn: {
        detail: 'Изглед'
    },
    setting: {
        customEntry: 'Бързо влизане',
        systemSwitch: 'Системна конфигурация',
        isMock: 'Дали Mock',
        isHotKey: 'Дали клавиш за бърз достъп',
        isBreadCrumb: 'Дали трохи от хляб',
        isCache: 'Дали да кеширам',
        isI18n: 'Дали да се интернационализира'
    },
    pagingInfo: {
        total: 'Общо',
        uint: 'Член',
        items: 'запис'
    }
}
